/**
 * The PermissionCatalog codes the SPA checks — the ones a route, a sidebar entry or a control is
 * gated on today, not the whole catalogue. A code checked as a string literal compiled for any
 * typo and failed closed without a word; named here, a misspelling is a type error.
 *
 * `:own` / `:any` are part of the code, as the backend grants it.
 */
export const PERMISSION = {
  contentManage: 'content.manage',
  contentApprove: 'content.approve',
  usersAdmin: 'users.admin',
  auditRead: 'audit.read',
  nomenclatureAdmin: 'nomenclature.admin',
  geoAdmin: 'geo.admin',
  backupManage: 'backup.manage',
  reportsRead: 'reports.read',
  fundingManage: 'funding.manage',
  workflowAdmin: 'workflow.admin',
  advisorsValidate: 'advisors.validate',
  advisorsCertify: 'advisors.certify',
  forumsModerate: 'forums.moderate',
  profileEdit: 'profile.edit',
  applicationsCreateOwn: 'applications.create:own',
  applicationsReadAny: 'applications.read:any',
  applicationsApproveAny: 'applications.approve:any',
  applicationsDownloadAny: 'applications.download:any',
  researchContribute: 'research.contribute',
  researchAdoptionReport: 'research.adoption_report',
  eventsManage: 'events.manage',
  eventsContribute: 'events.contribute',
  scientificEventsCreate: 'scientific_events.create',
  trainingManage: 'training.manage',
  trainingInstitutionsManageAny: 'training_institutions.manage:any',
  consultancyInstitutionsManageAny: 'consultancy_institutions_registry.manage:any',
  researchOrgsManageAny: 'research_orgs_registry.manage:any',
} as const;
